import React, { useContext, useEffect } from 'react'
import './SingleItem.css'
import { BasketContext } from '../BasketContext';

export default function SingleItem(props) {

    const { basket, setBasket } = useContext(BasketContext);

    const AddToBasket = () => {
        let myItem = props.Item;
        let InCheck = false;
        var newBasket = []

        if (!localStorage.getItem("LocalBasket") || localStorage.getItem("LocalBasket") === "null") {
            myItem.Quantity = 1;
            newBasket = [myItem]
            setBasket(newBasket)
            //localStorage.setItem("LocalBasket", JSON.stringify(newBasket))
            //updateLocalBasket(newBasket)
            return
        } else {
            newBasket = localStorage.getItem("LocalBasket") ? JSON.parse(localStorage.getItem("LocalBasket")) : [];
        }

        let alreadyIn = newBasket.map(function (basketItem) {
            myItem.Quantity += 1
            if (myItem.ItemID === basketItem.ItemID) {
                InCheck = true
                return true
            }
        })

        console.log(alreadyIn ? "Already in basket" : "Not in basket")

        if (InCheck === false) {
            myItem.Quantity = 1;
            newBasket = [...newBasket, myItem]
            setBasket(newBasket)
            //localStorage.setItem("LocalBasket", JSON.stringify(newBasket))
            //updateLocalBasket(newBasket)
            return
        }

    };

    useEffect(() => {
        localStorage.setItem("LocalBasket", JSON.stringify(basket))
    }, [basket])

    const ItemClickHandler = (props) => {
    }

    const currency = 'R'
    const showOverlay = true
    let itemDetail = showOverlay ? (
        <>
            <div className="item-Descript">
                <p>{props.Item.Description}</p>
            </div>
            <div className="item-price">
                <span className="priceP"><b>{currency + props.Item.BasePrice} </b></span><br /><br />
                {localStorage.getItem('token') && <span className="buttonP" onClick={AddToBasket}>Add to Basket</span>}
            </div>
        </>
    ) : (<></>)

    return (
        <div className="grid-item" onClick={ItemClickHandler}>
            <div className='img-cont'>
                <img src={'https://dblla03zmq1su.cloudfront.net/' + props.Item.ItemID + '.png'}
                    alt={props.Item.Description}
                    loading='eager'></img>
            </div>
            {itemDetail}
        </div>
    )
}
